<template>
    <div>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Project status') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                <div>{{ __attr(project.status) }}</div>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Project type') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                {{ __attr(project.type) }}
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Project number') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                {{ project.code }}
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Project name') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                <div>{{ project.name }}</div>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Project target') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                <div v-html="project.target"/>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Created at') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                 <div>{{ utcToLocalDateTimeLess(project.created_at) }}</div>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Updated at') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                 <div>{{ utcToLocalDateTimeLess(project.updated_at) }}</div>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Reference') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                <div v-html="project.reference"/>
                <div>
                    <single-file-item v-for="file in referenceFiles"
                            :key="`file-${file.id}`"
                            :file="file"/>
                </div>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row dense>
            <v-col cols="12" sm="5" lg="3" class="text-sm-left">
                <label class="font-weight-bold">{{ $t('Application') }}</label>
            </v-col>
            <v-col cols="12" sm="7" lg="9">
                <div v-html="project.application"/>
                <div>
                    <single-file-item v-for="file in applicationFiles"
                    :key="`file-${file.id}`"
                    :file="file"/>
                </div>
            </v-col>
        </v-row>
        <v-divider class="my-3"/>
    </div>
</template>

<script>
import { get } from 'vuex-pathify'
import SingleFileItem from '@components/SingleFileItem'
import { utcToLocalDateTimeLess } from '@utils'

export default {
  name: 'ShowBasicInfo',
  props: [
    'project'
  ],
  components: {
    SingleFileItem
  },
  computed: {
    ...get('project', [
      'applicationFiles',
      'referenceFiles'
    ])
  },
  methods: {
    utcToLocalDateTimeLess
  }
}
</script>
